export default "__VITE_ASSET__49787abb__"